<template>
  <div class="xcard">
    <h3 class="text-primary text-center" style="margin-top: 0">Reporte de Markerting</h3>
    <p class="text-center">
      Generacion de reporte por cada sede, tomando en cuenta todas las inscripciones incluso con los asesores de otras
      sedes.
    </p>
    <hr />

    <div class="row">
      <div class="col-sm-5">
        <Sedes :model="sede" />
      </div>

      <div class="col-sm-7">
        <div class="col-sm-5" :class="{ 'has-error': validation.hasError('busqueda.fecha_ini') }">
          <Fecha :model="busqueda" :valueto="'fecha_ini'" :default="busqueda.fecha_ini" />
          <small>Desde cuando</small>
          <div class="error" v-if="validation.hasError('busqueda.fecha_ini')">
            {{ validation.firstError('busqueda.fecha_ini') }}
          </div>
        </div>
        <div class="col-sm-5" :class="{ 'has-error': validation.hasError('busqueda.fecha_fin') }">
          <Fecha :model="busqueda" :valueto="'fecha_fin'" :default="busqueda.fecha_fin" />
          <small>Hasta (ahora)</small>
          <div class="error" v-if="validation.hasError('busqueda.fecha_fin')">
            {{ validation.firstError('busqueda.fecha_fin') }}
          </div>
        </div>
        <div class="col-sm-2">
          <button class="btn btn-sm btn-primary" @click="clickBuscar()">Buscar</button>
        </div>
      </div>
    </div>

    <Alertas ref="alertar" />

    <p class="text-danger">
      <small>Cursos:</small>
      <button
        v-show="datos.cursos.length > 0"
        class="btn btn-sm btn-link"
        @click="tableToExcel('tablec', 'reporte_cursos')">
        <span class="glyphicon glyphicon-print"></span> Reporte EXCEL
      </button>
    </p>
    <table ref="tablec" class="table table-condensed table-striped xcard" style="border: 1px solid #4a8f2e">
      <caption v-show="false">
        Reporte de inscripciones por curso:
      </caption>
      <thead>
        <tr style="background: #4a8f2e; color: white">
          <th><small>No</small></th>
          <th style="width: 600px"><small>Nombre del curso</small></th>
          <th><small>Inscritos</small></th>
          <th><small>Asesores que inscribieron</small></th>
        </tr>
      </thead>
      <tbody>
        <tr :key="ind" v-for="(p, ind) in datos.cursos">
          <td>{{ ind + 1 }}</td>
          <td>{{ p.programa.nombre }}</td>
          <td>{{ p.programa.cantidad }}</td>
          <td>
            <p :key="i" v-for="(a, i) in p.programa.asesores" class="row_asesor">
              <small>{{ a.nombre }} {{ a.cantidad }}</small>
            </p>
          </td>
        </tr>
      </tbody>
    </table>

    <p class="text-danger">
      <small>Diplomados:</small>
      <button
        v-show="datos.diplomados.length > 0"
        class="btn btn-sm btn-link"
        @click="tableToExcel('tabled', 'reporte_diplomados')">
        <span class="glyphicon glyphicon-print"></span> Reporte EXCEL
      </button>
    </p>
    <table ref="tabled" class="table table-condensed table-striped xcard" style="border: 1px solid #7f6000">
      <caption v-show="false">
        Reporte de inscripciones por diplomados:
      </caption>
      <thead>
        <tr style="background: #7f6000; color: white">
          <th><small>No</small></th>
          <th style="width: 600px"><small>Nombre del diplomado</small></th>
          <th><small>Inscritos</small></th>
          <th><small>Asesores que inscribieron</small></th>
        </tr>
      </thead>
      <tbody>
        <tr :key="ind" v-for="(p, ind) in datos.diplomados">
          <td>{{ ind + 1 }}</td>
          <td>{{ p.programa.nombre }}</td>
          <td>{{ p.programa.cantidad }}</td>
          <td>
            <p :key="i" v-for="(a, i) in p.programa.asesores" class="row_asesor">
              <small>{{ a.nombre }} {{ a.cantidad }}</small>
            </p>
          </td>
        </tr>
      </tbody>
    </table>

    <p class="text-danger">
      <small>Especialidades:</small>
      <button
        v-show="datos.especialidades.length > 0"
        class="btn btn-sm btn-link"
        @click="tableToExcel('tablee', 'reporte_especialidades')">
        <span class="glyphicon glyphicon-print"></span> Reporte EXCEL
      </button>
    </p>
    <table ref="tablee" class="table table-condensed table-striped xcard" style="border: 1px solid #37598f">
      <caption v-show="false">
        Reporte de inscripciones por especialidades:
      </caption>
      <thead>
        <tr style="background: #37598f; color: white">
          <th><small>No</small></th>
          <th style="width: 600px"><small>Nombre de la especialidad</small></th>
          <th><small>Inscritos</small></th>
          <th><small>Asesores que inscribieron</small></th>
        </tr>
      </thead>
      <tbody>
        <tr :key="ind" v-for="(p, ind) in datos.especialidades">
          <td>{{ ind + 1 }}</td>
          <td>{{ p.programa.nombre }}</td>
          <td>{{ p.programa.cantidad }}</td>
          <td>
            <p :key="i" v-for="(a, i) in p.programa.asesores" class="row_asesor">
              <small>{{ a.nombre }} {{ a.cantidad }}</small>
            </p>
          </td>
        </tr>
      </tbody>
    </table>

    <p class="text-danger">
      <small>Maestrias:</small>
      <button
        v-show="datos.maestrias.length > 0"
        class="btn btn-sm btn-link"
        @click="tableToExcel('tablem', 'reporte_maestrias')">
        <span class="glyphicon glyphicon-print"></span> Reporte EXCEL
      </button>
    </p>
    <table ref="tablem" class="table table-condensed table-striped xcard" style="border: 1px solid #695f87">
      <caption v-show="false">
        Reporte de inscripciones por maestrias:
      </caption>
      <thead>
        <tr style="background: #695f87; color: white">
          <th><small>No</small></th>
          <th style="width: 600px"><small>Nombre de la Maestria</small></th>
          <th><small>Inscritos</small></th>
          <th><small>Asesores que inscribieron</small></th>
        </tr>
      </thead>
      <tbody>
        <tr :key="ind" v-for="(p, ind) in datos.maestrias">
          <td>{{ ind + 1 }}</td>
          <td>{{ p.programa.nombre }}</td>
          <td>{{ p.programa.cantidad }}</td>
          <td>
            <p :key="i" v-for="(a, i) in p.programa.asesores" class="row_asesor">
              <small>{{ a.nombre }} {{ a.cantidad }}</small>
            </p>
          </td>
        </tr>
      </tbody>
    </table>

    <p class="text-danger"><small> Graficos: </small></p>
    <div class="row">
      <div class="col-sm-6">
        <div class="xcard">
          <small class="text-primary">Inscripciones a Cursos</small>
          <canvas id="chart-area1"></canvas>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="xcard">
          <small class="text-primary">Inscripciones a Diplomados</small>
          <canvas id="chart-area2"></canvas>
        </div>
      </div>
    </div>
    <p></p>

    <div class="row">
      <div class="col-sm-6">
        <div class="xcard">
          <small class="text-primary">Inscripciones a Especialidades</small>
          <canvas id="chart-area3"></canvas>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="xcard">
          <small class="text-primary">Inscripciones a Maestrias</small>
          <canvas id="chart-area4"></canvas>
        </div>
      </div>
    </div>
    <p></p>

    <div class="row">
      <div class="col-sm-6">
        <div class="xcard">
          <small class="text-primary">Inscripciones general por categoria</small>
          <canvas id="chart-area5"></canvas>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="xcard">
          <small class="text-primary">Inscripciones general por programas</small>
          <canvas id="chart-area6"></canvas>
        </div>
      </div>
    </div>

    <notifications group="auth" position="bottom right" />
  </div>
</template>

<style lang="css" scoped>
  .row_asesor {
    margin: 0 !important;
  }
</style>

<script>
  import Sedes from '@/components/ASedes';
  import Alertas from '@/components/AAlertas.vue';
  import { parseJsonError, error } from '@/components/Utils.js';
  import { Validator } from 'simple-vue-validator';
  import Fecha from '@/components/AFecha.vue';
  import gql from 'graphql-tag';

  export default {
    data() {
      return {
        // EXCEL
        uri: 'data:application/vnd.ms-excel;base64,',
        template:
          '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
        base64: function (s) {
          return window.btoa(unescape(encodeURIComponent(s)));
        },
        format: function (s, c) {
          return s.replace(/{(\w+)}/g, function (m, p) {
            return c[p];
          });
        },
        // END EXCEL

        colores: [],
        datos: {
          cursos: [], //id=5
          diplomados: [], //id=1
          especialidades: [], //id=2
          maestrias: [], //id=3
          chartHelper: null,
        },
        sede: { idsede: {}, idusuario: [] },
        busqueda: { fecha_ini: null, fecha_fin: null },
      };
    },
    components: { Sedes, Fecha, Alertas },
    validators: {
      'busqueda.fecha_ini'(value) {
        return Validator.value(value).required();
      },
      'busqueda.fecha_fin'(value) {
        return Validator.value(value).required();
      },
    },
    methods: {
      tableToExcel(table, name) {
        /*if (!table.nodeType) */ table = this.$refs[table];
        var ctx = { worksheet: name || 'Worksheet', table: table.innerHTML };
        var link = document.createElement('a');
        link.download = name + '.xls';
        link.href = this.uri + this.base64(this.format(this.template, ctx));
        link.click();
      },
      async clickBuscar() {
        if (!this.busqueda.fecha_ini || !this.busqueda.fecha_fin || this.sede.idsede.id == null) {
          this.$notify(error('Faltan parametros', 'Complete los campos'));
          return;
        }
        this.$refs.alertar.cargando();
        this.datos = {
          cursos: [], //id=5
          diplomados: [], //id=1
          especialidades: [], //id=2
          maestrias: [], //id=3
        };

        var vue = this;
        var sql = gql`
      query{
        getInscripcionesBySede(sede:${this.sede.idsede.id},fechas:{fecha_ini:"${this.busqueda.fecha_ini}",fecha_fin:"${this.busqueda.fecha_fin}"}){
          id
          estado_ins
          programa{ id,postgrado{id,nombre,categoria{id,nombre}} }
          asesor{id,nombres,pri_apellido,seg_apellido}
        }
      }`;
        //window.console.log( sql )

        await this.$apollo
          .query({
            query: sql,
          })
          .then((data) => {
            //var lista = data.data.getInscripcionesBySede;
            this.$refs.alertar.reset();
            //window.console.log( lista )
            this.parseDatos(data);
          })
          .catch((error) => {
            vue.$refs.alertar.reset();
            window.console.error(error);
            this.$notify(parseJsonError(error, 'getInscripcionesBySede'));
          });
      },

      parseDatos(datos) {
        // { programa:{id:-1,nombre:"diplomado",cantidad:0,asesores:[ {id:-1,cantidad:0,nombre:"pedro"} ] } }
        var res = {
          cursos: [], //id=5
          diplomados: [], //id=1
          especialidades: [], //id=2
          maestrias: [], //id=3
        };

        //var pres = 0;
        datos.data.getInscripcionesBySede.forEach(function (e) {
          if (e.estado_ins != 0) {
            var tipo = e.programa.postgrado.categoria.id;
            var pid = e.programa.id;
            var pro = null;

            //window.console.log("---cate",e.programa.postgrado.categoria);

            // buscamos 24,25,26,28 es para dbs, 10,7 es cca
            let tipoccaall = tipo >= 6;
            if (tipo == 1 || tipo == 24) pro = res.diplomados.find((x) => x.programa.id == pid);
            else if (tipo == 2 || tipo == 25) pro = res.especialidades.find((x) => x.programa.id == pid);
            else if (tipo == 3 || tipo == 26) pro = res.maestrias.find((x) => x.programa.id == pid);
            else if (tipo == 5 || tipo == 28 || tipoccaall) pro = res.cursos.find((x) => x.programa.id == pid);

            // agregamos
            if (!pro) {
              if (tipo == 1 || tipo == 24)
                res.diplomados.push({
                  programa: { id: pid, nombre: e.programa.postgrado.nombre, cantidad: 0, asesores: [] },
                });
              else if (tipo == 2 || tipo == 25)
                res.especialidades.push({
                  programa: { id: pid, nombre: e.programa.postgrado.nombre, cantidad: 0, asesores: [] },
                });
              else if (tipo == 3 || tipo == 26)
                res.maestrias.push({
                  programa: { id: pid, nombre: e.programa.postgrado.nombre, cantidad: 0, asesores: [] },
                });
              else if (tipo == 5 || tipo == 28 || tipoccaall)
                res.cursos.push({
                  programa: { id: pid, nombre: e.programa.postgrado.nombre, cantidad: 0, asesores: [] },
                });
            }

            // volvemos a buscar
            if (tipo == 1 || tipo == 24) pro = res.diplomados.find((x) => x.programa.id == pid);
            else if (tipo == 2 || tipo == 25) pro = res.especialidades.find((x) => x.programa.id == pid);
            else if (tipo == 3 || tipo == 26) pro = res.maestrias.find((x) => x.programa.id == pid);
            else if (tipo == 5 || tipo == 28 || tipoccaall) pro = res.cursos.find((x) => x.programa.id == pid);
            if (!e.asesor) e.asesor = {};
            pro = pro.programa;
            pro.cantidad += 1;
            var aid = e.asesor.id;
            var ase = pro.asesores.find((x) => x.id == aid);
            if (ase) {
              ase.cantidad += 1;
            } else {
              pro.asesores.push({ id: aid, cantidad: 1, nombre: e.asesor.nombres + ' ' + e.asesor.pri_apellido });
            }
          }
          //else{ pres += 1}
        });

        //window.console.log( "---------------> ",pres )
        this.datos.cursos = res.cursos;
        this.datos.diplomados = res.diplomados;
        this.datos.especialidades = res.especialidades;
        this.datos.maestrias = res.maestrias;

        this.datos.cursos.sort(function (a, b) {
          return a.programa.cantidad - b.programa.cantidad;
        });

        //window.console.log( "--",res )
        this.crearGraficoGeneral2('chart-area6'); // genera los colores xD
        this.crearGrafico(this.datos.cursos, 'chart-area1');
        this.crearGrafico(this.datos.diplomados, 'chart-area2');
        this.crearGrafico(this.datos.especialidades, 'chart-area3');
        this.crearGrafico(this.datos.maestrias, 'chart-area4');
        this.crearGraficoGeneral('chart-area5');
      },
      crearGrafico(tipo, idcanvas) {
        // asesores = {id:-1,nombre:'',cantidad:''}
        var asesores = [];
        var cantidades = [];
        tipo.forEach(function (pp) {
          pp.programa.asesores.forEach(function (e) {
            var existe = asesores.find((x) => x.id == e.id);
            if (existe) {
              existe.cantidad += e.cantidad;
            } else {
              asesores.push({ id: e.id, nombre: e.nombre, cantidad: e.cantidad });
            }
          });
        });
        asesores.sort(function (a, b) {
          return a.cantidad - b.cantidad;
        });

        asesores.forEach(function (e) {
          cantidades.push(e.cantidad);
        });

        var config = {
          type: 'pie',
          data: {
            datasets: [{ data: cantidades, backgroundColor: this.colores, label: 'Grafico Cursos' }],
            labels: [],
          },
          options: {
            responsive: true,
            tooltips: {
              callbacks: {
                label: function (tooltipItem, data) {
                  window.console.log(tooltipItem);
                  var label = asesores[tooltipItem.index].nombre || '';
                  if (label) {
                    label += ': ';
                  }
                  var cant = data.datasets[0].data[tooltipItem.index] || '';
                  return label + cant;
                },
              },
            },
          },
        };

        //window.console.log( window.stringifyObject(cantidades))
        var ctx1 = document.getElementById(idcanvas).getContext('2d');
        new window.Chart(ctx1, config);
      },

      crearGraficoGeneral(idcanvas) {
        var cantidadesStr = [];
        var cantidadesNum = [];
        var categorias = [];
        var cant = 0;
        this.datos.cursos.forEach(function (e) {
          cant += e.programa.cantidad;
        });
        categorias.push({ n: 'Cursos', cantidad: cant });
        cant = 0;

        this.datos.diplomados.forEach(function (e) {
          cant += e.programa.cantidad;
        });
        categorias.push({ n: 'Diplomados', cantidad: cant });
        cant = 0;

        this.datos.especialidades.forEach(function (e) {
          cant += e.programa.cantidad;
        });
        categorias.push({ n: 'Especialidades', cantidad: cant });
        cant = 0;

        this.datos.maestrias.forEach(function (e) {
          cant += e.programa.cantidad;
        });
        categorias.push({ n: 'Maestrias', cantidad: cant });
        cant = 0;

        categorias.sort(function (a, b) {
          return a.cantidad - b.cantidad;
        });
        categorias.forEach(function (e) {
          cantidadesStr.push(e.n);
          cantidadesNum.push(e.cantidad);
        });

        var config = {
          type: 'pie',
          data: {
            datasets: [{ data: cantidadesNum, backgroundColor: this.colores, label: 'Grafico General' }],
            labels: [],
          },
          options: {
            responsive: true,
            tooltips: {
              callbacks: {
                label: function (tooltipItem, data) {
                  window.console.log(tooltipItem);
                  var label = cantidadesStr[tooltipItem.index] || '';
                  if (label) {
                    label += ': ';
                  }
                  var cant = data.datasets[0].data[tooltipItem.index] || '';
                  return label + cant;
                },
              },
            },
          },
        };

        //window.console.log( window.stringifyObject(cantidades))
        var ctx1 = document.getElementById(idcanvas).getContext('2d');
        new window.Chart(ctx1, config);
      },

      crearGraficoGeneral2(idcanvas) {
        var cantidadesStr = [];
        var cantidadesNum = [];
        var vue = this;

        var categorias = [];
        this.datos.cursos.forEach(function (e) {
          categorias.push({ n: e.programa.nombre, cantidad: e.programa.cantidad });
        });
        this.datos.diplomados.forEach(function (e) {
          categorias.push({ n: e.programa.nombre, cantidad: e.programa.cantidad });
        });
        this.datos.especialidades.forEach(function (e) {
          categorias.push({ n: e.programa.nombre, cantidad: e.programa.cantidad });
        });
        this.datos.maestrias.forEach(function (e) {
          categorias.push({ n: e.programa.nombre, cantidad: e.programa.cantidad });
        });

        categorias.sort(function (a, b) {
          return a.cantidad - b.cantidad;
        });
        categorias.forEach(function (e) {
          cantidadesStr.push(e.n);
          cantidadesNum.push(e.cantidad);
          vue.colores.push('#' + Math.floor(Math.random() * 16777215).toString(16));
        });

        var i = 0;
        for (i = 0; i < 10; i++) vue.colores.push('#' + Math.floor(Math.random() * 16777215).toString(16));

        var config = {
          type: 'pie',
          data: {
            datasets: [{ data: cantidadesNum, backgroundColor: vue.colores, label: 'Grafico General' }],
            labels: [],
          },
          options: {
            responsive: true,
            tooltips: {
              callbacks: {
                label: function (tooltipItem, data) {
                  window.console.log(tooltipItem);
                  var label = cantidadesStr[tooltipItem.index] || '';
                  if (label) {
                    label += ': ';
                  }
                  var cant = data.datasets[0].data[tooltipItem.index] || '';
                  return label + cant;
                },
              },
            },
          },
        };

        //window.console.log( window.stringifyObject(cantidades))
        var ctx1 = document.getElementById(idcanvas).getContext('2d');
        new window.Chart(ctx1, config);
      },
    },
    mounted() {
      var date = new Date();
      var dia = date.getDate();
      var mes = date.getMonth() + 1;
      var anio = date.getFullYear();
      if (dia < 10) dia = '0' + dia;
      if (mes < 10) mes = '0' + mes;
      this.busqueda.fecha_fin = anio + '-' + mes + '-' + dia;
    },
  };
</script>
